<template>
    <div v-if="isOpen" name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click.self="close">
                <div
                    class="modal-container"
                    :class="[
                        currentSizeClass
                            ? `modal-container-${currentSizeClass}`
                            : '',
                    ]"
                >
                    <button class="modal__close" @click.self="close"></button>
                    <div v-if="hasHeaderSlot" class="modal-header">
                        <slot name="header"></slot>
                    </div>

                    <div v-if="hasBodySlot" class="modal-middle">
                        <slot name="body"></slot>
                    </div>

                    <slot v-if="hasDefaultSlot"></slot>

                    <div v-if="hasFooterSlot" class="modal-footer">
                        <slot name="footer">
                            <button class="btn btn-primary" @click="close">
                                Закрыть
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const ALLOW_SIZED = {
        full: 'full',
        lg: 'lg',
        sm: 'sm',
        deprecated: 'deprecated',
    };

    export default {
        props: {
            sizeModal: {
                type: String,
                default: '',
            },
            isOpen: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['close', 'closed'],
        computed: {
            currentSizeClass() {
                return ALLOW_SIZED[this.sizeModal] || false;
            },
            hasHeaderSlot() {
                return !!this.$slots.header;
            },
            hasBodySlot() {
                return !!this.$slots.body;
            },
            hasFooterSlot() {
                return !!this.$slots.footer;
            },
            hasDefaultSlot() {
                return !!this.$slots.default;
            },
        },
        methods: {
            close() {
                /** Для совместимости с модалкой с языком closed */
                this.$emit('close');
                this.$emit('closed');
            },
        },
    };
</script>
